import React from 'react';
import { ForecastChart } from './ForecastChart';
import { MoneySavedCounter } from './MoneySavedCounter';
import { DarkModeToggle } from './DarkModeToggle';
import { useDarkMode } from '../hooks/useDarkMode';
export function BrochureLayout() {
  const {
    isDark,
    toggle
  } = useDarkMode();
  // Get current UTC date in YYYY-MM-DD format
  const currentUtcDate = new Date().toISOString().split('T')[0];
  return <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-950 transition-colors duration-500" data-id="element-22">
      {/* Subtle grid background */}
      <div className="fixed inset-0 bg-[linear-gradient(to_right,#8882_1px,transparent_1px),linear-gradient(to_bottom,#8882_1px,transparent_1px)] dark:bg-[linear-gradient(to_right,#ffffff05_1px,transparent_1px),linear-gradient(to_bottom,#ffffff05_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_0%,#000_70%,transparent_110%)] pointer-events-none opacity-40" data-id="element-23" />

      <div className="relative" data-id="element-24">
        {/* Header */}
        <header className="border-b border-slate-200 dark:border-slate-800 bg-white/80 dark:bg-slate-900/80 backdrop-blur-md" data-id="element-25">
          <div className="max-w-7xl mx-auto px-6 py-6" data-id="element-26">
            <div className="flex items-center justify-between" data-id="element-27">
              <div className="flex items-center gap-3" data-id="element-28">
                <div className="w-1 h-8 bg-gradient-to-b from-blue-500 to-purple-500 dark:from-blue-400 dark:to-purple-400 rounded-full shadow-lg dark:shadow-blue-500/30" data-id="element-29" />
                <div data-id="element-30">
                  <h1 className="text-4xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 dark:from-blue-400 dark:to-purple-400 bg-clip-text text-transparent" data-id="element-31">
                    VECTREI
                  </h1>
                  <p className="text-sm text-slate-600 dark:text-slate-400" data-id="element-32">
                    Proyección de CMg en tiempo real
                  </p>
                </div>
              </div>
              <DarkModeToggle isDark={isDark} onToggle={toggle} data-id="element-33" />
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="max-w-7xl mx-auto px-6 py-12" data-id="element-34">
          {/* First Chart - Subestación María Elena */}
          <div className="mb-16" data-id="element-35">
            <div className="mb-8 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6" data-id="element-36">
              <div data-id="element-37">
                <h2 className="text-3xl font-bold mb-3 text-slate-900 dark:text-slate-50" data-id="element-38">
                  Subestación María Elena 220
                </h2>
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-50 dark:bg-blue-500/10 text-blue-700 dark:text-blue-400 text-sm font-medium mb-3 border border-blue-100 dark:border-blue-500/20" data-id="element-39">
                  <div className="w-1.5 h-1.5 rounded-full bg-blue-500 dark:bg-blue-400 animate-pulse shadow-sm dark:shadow-blue-400/50" data-id="element-40" />
                  Proyección 24 horas
                </div>
                <p className="text-slate-600 dark:text-slate-400 max-w-md leading-relaxed" data-id="element-41">
                  Comparación entre nuestra proyección y el pronóstico del
                  Coordinador Eléctrico Nacional
                </p>
              </div>
              <MoneySavedCounter chartId="maria_elena" title="Diferencia Promedio" data-id="element-42" />
            </div>

            <div className="rounded-2xl shadow-xl shadow-slate-200/50 dark:shadow-black/20 overflow-hidden border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900" data-id="element-43">
              <ForecastChart prediction_date={currentUtcDate} title="CMG (USD/MWH)" chartId="maria_elena" showRealData={true} substation="maria_elena" showMetrics={false} data-id="element-44" />
            </div>
          </div>

          {/* Second Chart - Subestación Tamaya */}
          <div data-id="element-45">
            <div className="mb-8 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6" data-id="element-46">
              <div data-id="element-47">
                <h2 className="text-3xl font-bold mb-3 text-slate-900 dark:text-slate-50" data-id="element-48">
                  Subestación Tamaya 110
                </h2>
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-purple-50 dark:bg-purple-500/10 text-purple-700 dark:text-purple-400 text-sm font-medium mb-3 border border-purple-100 dark:border-purple-500/20" data-id="element-49">
                  <div className="w-1.5 h-1.5 rounded-full bg-purple-500 dark:bg-purple-400 animate-pulse shadow-sm dark:shadow-purple-400/50" data-id="element-50" />
                  Proyección 24 horas
                </div>
                <p className="text-slate-600 dark:text-slate-400 max-w-md leading-relaxed" data-id="element-51">
                  Análisis específico para la subestación Tamaya 110kV
                </p>
              </div>
              <MoneySavedCounter chartId="tamaya" title="Diferencia Promedio" data-id="element-52" />
            </div>

            <div className="rounded-2xl shadow-xl shadow-slate-200/50 dark:shadow-black/20 overflow-hidden border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900" data-id="element-53">
              <ForecastChart prediction_date={currentUtcDate} title="CMG (USD/MWH)" chartId="tamaya" showRealData={true} substation="tamaya_110" showMetrics={false} data-id="element-54" />
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="mt-24 border-t border-slate-200 dark:border-slate-800 bg-white/80 dark:bg-slate-900/80 backdrop-blur-md" data-id="element-55">
          <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-56">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-sm text-slate-600 dark:text-slate-400" data-id="element-57">
              <div data-id="element-58">© 2025 VECTREI</div>
              <div data-id="element-59">Sistema de Proyección de Energía</div>
            </div>
          </div>
        </footer>
      </div>
    </div>;
}